export default __webpack_public_path__ + "static/media/chatbot-bot-icon.b12a7fba.png";